import Layout from '../Layout';
import PageTemplate from '../PageTemplate';
import RecoveryLayout from './Layout';
import { useTranslation } from 'react-i18next';

interface Props {
  handleSubmit: () => void;
}

const FinishRecovery = ({ handleSubmit }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Layout>
      <RecoveryLayout>
        <PageTemplate
          title={`${t('password.new')} ${t('saved')}`}
          description={t('auth.restore.success')}
          submitButtonContent={t('auth.to.home')}
          submit={() => handleSubmit()}
        />
      </RecoveryLayout>
    </Layout>
  );
};

export default FinishRecovery;
